import { render, staticRenderFns } from "./MinimalFooter.vue?vue&type=template&id=11c54562&scoped=true"
import script from "./MinimalFooter.vue?vue&type=script&lang=js"
export * from "./MinimalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c54562",
  null
  
)

export default component.exports